/* eslint-disable */
import React, { Component } from "react";
import "./awsplateform.less";
import accImg from "./assets/accenture.png";
import awsImg from "./assets/samlogo.png";
import artImg from "./assets/art.png";
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import AwsAgenda from "./AwsAgenda";
import AwsHeader from "./AwsHeader";

/* ---------- Agenda data ---------- */
const AG = { "day1": { "keynote": [{ "start": "08:00", "end": "10:00", "title": "Registration & Networking", "speakers": [] }, { "start": "10:00", "end": "10:20", "title": "Gates Open", "speakers": [] }, { "start": "10:20", "end": "10:25", "title": "Opening Remarks by Emcee", "speakers": [] }, { "start": "10:25", "end": "10:35", "title": "Executive Keynote", "speakers": [["Alister Fraser", "Global Lead, Accenture AWS Business Group, AWS"]] }, { "start": "10:35", "end": "10:55", "title": "ATCI Leadership Address", "speakers": [["Aditi Kulkarni", "Lead — Global Technology Delivery & ATC Global Network, Accenture"]] }, { "start": "10:55", "end": "11:15", "title": "Keynote Session", "speakers": [["Praveen Sridhar", "Director of India Partnerships, AWS"]] }, { "start": "11:15", "end": "11:20", "title": "Closing Remarks by Emcee", "speakers": [] }], "tracks": [{ "room": "Convention Center", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM101", "title": "Kiro - Agentic IDE: The Agentic IDE for Prototype to Production", "speakers": [["Vipul Tankariya", "WW Partner Solutions Architect, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM105", "title": "AWS Partner-Led FDE: A Durable Delivery Model for Enterprise AI", "speakers": [["Karthik Sonti", "Sr Mgr WW Partner Sol PSA, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM108", "title": "Client-Centric Innovation with AI", "speakers": [["Arundhati Chakraborty", "GCC Lead"], ["Rinku Kaul", "ATCI HR Head"], ["Santha Subramoni", "CyberSecurity RP Lead"], ["Koushik Vijayraghavan", "Ecosystem & Talent RP Lead"], ["Chris Wegmann", "AABG Technology Lead"]], "moderator": ["Nitin Sawant", ""] }, { "start": "16:15", "end": "17:15", "code": "SAM111", "title": "Agentic SDLC", "speakers": [["Hari Thiagarajan", "Principal Customer Success Specialist, AWS"], ["Nahuel Franchi", "Principal Customer Success Specialist, AWS"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Scarlet 1 Ballroom", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM102", "title": "AI-DLC Methodology: Redefining the Software Development Lifecycle", "speakers": [["Anurag Vikram Singh", "Solutions Architect, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM106", "title": "Amazon Connect Agentic AI: Intelligent Agents for Every Layer of CX", "speakers": [["Dilin Joy", "Senior Partner Solutions Architect, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM109", "title": "Kiro Deep Dive - Autonomous Agent, Powers & MCP: Extending Agent Capabilities with Best Practices", "speakers": [["Ramesh Ranganathan", "SA Leader, AWS"]] }, { "start": "16:15", "end": "17:15", "code": "SAM112", "title": "Agentic AI led SAP Transformations with Accenture & AWS", "speakers": [["Balamurali Muraleedharan", "Solutions Architect, AWS"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Zinnia Hall", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM103", "title": "Amazon Quick", "speakers": [["Nidhi Seth", "Senior Partner Trainer, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM107", "title": "Amazon Bedrock: Building Intelligent Applications at Scale", "speakers": [["Dhiraj Thakur", "WW Partner Solutions Architect, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM110", "title": "Trust Nothing the Model Says: Mechanical Enforcement for Regulated AI", "speakers": [["Mihir Desai", "Senior Solutions Architect, AWS"], ["Anubhav Gupta", "Senior Solutions Architect, AWS"]] }, { "start": "16:15", "end": "17:15", "code": "SAM113", "title": "Accenture Secure Cloud Foundation and Cyber.AI Offering Breakout", "speakers": [["Manu Prasad", "Product Manager, Secure Cloud Foundation"], ["Monalisa Kaur", "Architect, Secure Cloud Foundation"], ["Prathima Kasagar", "ATCI Cybersecurity responsible for Cyber Services (transformation)"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Scarlet 2 & 3 Ballroom", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM104", "title": "AI-DLC in Practice: From Inception to Operation - Part 1", "speakers": [["Sunil Prasad", "Partner Solution Architect, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM104", "title": "AI-DLC in Practice: From Inception to Operation - Part 2", "speakers": [["Sunil Prasad", "Partner Solution Architect, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM114", "title": "AWS Transform — Automate Your Code Transformations and Retire Tech Debt at Scale - Part 1", "speakers": [["Parijat Avasthi", "WW AABG - Sr. Partner Solution Architect"], ["Joel Rosenberger", "Chief Architect, Managing Director, AWS Mainframe Modernization, Accenture"], ["Mike Rutherford", "Accenture AWS Business Group Global Migration and Modernization Offering Lead, Accenture"]] }, { "start": "16:15", "end": "17:15", "code": "SAM114", "title": "AWS Transform — Automate Your Code Transformations and Retire Tech Debt at Scale - Part 2", "speakers": [["Parijat Avasthi", "WW AABG - Sr. Partner Solution Architect"], ["Joel Rosenberger", "Chief Architect, Managing Director, AWS Mainframe Modernization, Accenture"], ["Mike Rutherford", "Accenture AWS Business Group Global Migration and Modernization Offering Lead, Accenture"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }] }, "day2": { "keynote": [{ "start": "08:00", "end": "10:00", "title": "Registration & Networking", "speakers": [] }, { "start": "10:00", "end": "10:20", "title": "Gates Open", "speakers": [] }, { "start": "10:20", "end": "10:25", "title": "Opening Remarks by Emcee", "speakers": [] }, { "start": "10:25", "end": "10:35", "title": "Executive Keynote", "speakers": [["Alister Fraser", "Global Lead, Accenture AWS Business Group, AWS"]] }, { "start": "10:35", "end": "10:55", "title": "ATCI Leadership Address", "speakers": [["Raghavan Iyer", "Supply Chain & Engineering RP Lead, Accenture"]] }, { "start": "10:55", "end": "11:15", "title": "Keynote Session", "speakers": [["Praveen Sridhar", "Director of India Partnerships, AWS"]] }, { "start": "11:15", "end": "11:20", "title": "Closing Remarks by Emcee", "speakers": [] }], "tracks": [{ "room": "Convention Center", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM201", "title": "AI-DLC Methodology: Redefining the Software Development Lifecycle", "speakers": [] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM205", "title": "AWS Transform for Migrations", "speakers": [["Parijat Avasthi", "Sr. Partner Solution Architect, Accenture"], ["Kimberlee Carlile", "Global Partner Development Manager, AWS"], ["Mike Rutherford", "Accenture AWS Business Group - Global Migration and Modernization Offering Lead, Accenture"]] }, { "start": "15:00", "end": "16:00", "code": "SAM208", "title": "The Power of Together: AWS, Accenture, and the Future of AI-Powered Development", "speakers": [["Shylaja Shivraman", "SMD - Digital Core RP Lead, Accenture"], ["Wayne Saxe", "Global Head of Solutions Architecture for the Accenture AWS Business Group, AWS"], ["Santha Subramoni", "CyberSecurity RP Lead"], ["Mukesh Chaudhury", "SMD - Accenture Data & AI Lead"]], "moderator": ["Kimberlee Carlile", "Partner Development Manager, AWS"] }, { "start": "16:15", "end": "17:15", "code": "SAM211", "title": "From 10 Days to 5 Minutes: Building Agentic Lending on AWS", "speakers": [["Mihir Desai", "Senior Solutions Architect, AWS"], ["Anubhav Gupta", "Senior Solutions Architect, AWS"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Scarlet 1 Ballroom", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM202", "title": "Kiro - Agentic IDE: The Agentic IDE for Prototype to Production", "speakers": [["Vipul Tankariya", "WW Partner Solutions Architect, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM206", "title": "AgentCore: Orchestrating AI Agents from Prototype to Production", "speakers": [["Gurudath Pai", "Sr. Partner Solutions Architect, PGS, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM209", "title": "Agent POC to Production: Security, Cost Control and the Agents You Inherited", "speakers": [["Ashish Mali", "Partner Sales Manager, Lyzr AI"], ["Sri Suhas", "Product Manager, Lyzr AI"], ["Suyash Mankar", "Product Manager, Lyzr AI"], ["Rasswanth Shankar", "Founding Platform Engineer, Lyzr AI"]] }, { "start": "16:15", "end": "17:15", "code": "SAM212", "title": "Open AI session", "speakers": [["Shikhar Kwatra", "Partner Applied AI Engineering Head, Americas, OpenAI"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Zinnia Hall", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM203", "title": "AWS Transform: Reimagining Mainframe Applications From Monolith to Agent-Native", "speakers": [["Mahesh Jadhav", "Principal Partner Solutions Architect, AWS"], ["Joel Rosenberger", "Accenture Mainframe WW Lead"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM207", "title": "APT: Agentic Process Transformation Program for Partners", "speakers": [["Ankit Agarwal", "PGS, Strategic Initiatives Leader, AWS"], ["Mahesh Jadhav", "Principal Partner Solutions Architect, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM210", "title": "Agentic SDLC", "speakers": [["Sergio", ""], ["Hari Thiagarajan", "Principal Customer Success Specialist, AWS"]] }, { "start": "16:15", "end": "17:15", "code": "SAM213", "title": "Amazon Connect Customer: Agentic AI-Powered CX Development with Kiro & Quick", "speakers": [["Dilin Joy", "Senior Partner Solutions Architect, AWS"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }] }, { "room": "Scarlet 2 & 3 Ballroom", "sessions": [{ "start": "11:45", "end": "12:45", "code": "SAM204", "title": "Kiro: Spec-Driven Development with Kiro - Part 1", "speakers": [["Mansi Suratwala", "Sr. Partner Solution Architect, AABG, AWS"]] }, { "start": "12:45", "end": "13:45", "code": "", "title": "Lunch Break", "speakers": [] }, { "start": "13:45", "end": "14:45", "code": "SAM204", "title": "Kiro: Spec-Driven Development with Kiro - Part 2", "speakers": [["Mansi Suratwala", "Sr. Partner Solution Architect, AABG, AWS"]] }, { "start": "15:00", "end": "16:00", "code": "SAM214", "title": "Building AI Agents with Bedrock & AgentCore - Part 1", "speakers": [["Kamaldeep Tumkur", "Partner Solution Architect, AWS"], ["Sunil Prasad", "Partner Solution Architect, AWS"]] }, { "start": "16:15", "end": "17:15", "code": "SAM214", "title": "Building AI Agents with Bedrock & AgentCore - Part 2", "speakers": [["Kamaldeep Tumkur", "Partner Solution Architect, AWS"], ["Sunil Prasad", "Partner Solution Architect, AWS"]] }, { "start": "17:15", "end": null, "code": "", "title": "Networking", "speakers": [] }], "workshop": true }] } };

/* Mockup ke liye simulated "now": Day 1, 03:20 PM */
const SIM = { day: "day1", min: 15 * 60 + 20 };

const DAYS = [
  { key: "day1", label: "Day 1", date: "Tue, Oct 13" },
  { key: "day2", label: "Day 2", date: "Wed, Oct 14" },
];

/* ---------- Helpers ---------- */
const toMin = (t) => {
  const p = t.split(":");
  return +p[0] * 60 + +p[1];
};

const t12 = (t) => {
  if (!t) return "";
  const p = t.split(":");
  let h = +p[0];
  const ap = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return (h < 10 ? "0" : "") + h + ":" + p[1] + " " + ap;
};

const getStatus = (day, s, e) => {
  if (day !== SIM.day) return day < SIM.day ? "done" : "soon";
  const a = toMin(s);
  const b = e ? toMin(e) : a + 60;
  return SIM.min < a ? "soon" : SIM.min < b ? "live" : "done";
};

const WM_PATH =
  "M385.70,20.10 L385.10,20.60 L384.90,21.20 L384.90,62.90 L385.20,63.60 L385.80,63.90 L394.50,63.90 L395.00,63.70 L395.50,62.90 L395.50,21.30 L395.00,20.30 L393.90,20.00Z M213.20,20.00 L212.50,20.20 L212.10,20.60 L211.90,21.20 L211.90,62.90 L212.20,63.60 L212.80,63.90 L221.50,63.90 L222.00,63.70 L222.50,62.90 L222.50,21.30 L222.00,20.30 L220.90,20.00Z M201.60,19.70 L200.60,19.50 L197.00,20.00 L194.50,21.00 L192.20,22.40 L189.00,25.60 L188.60,25.60 L188.20,25.00 L188.20,21.30 L188.00,20.60 L187.40,20.10 L179.10,20.00 L178.60,20.10 L177.90,20.60 L177.60,22.00 L177.60,62.40 L177.70,63.10 L178.30,63.80 L187.30,63.90 L188.00,63.40 L188.20,62.80 L188.20,40.60 L188.40,38.70 L189.00,36.20 L189.60,34.90 L190.60,33.40 L192.30,31.90 L196.40,30.00 L200.60,29.60 L201.40,29.40 L201.90,29.00 L202.30,27.70 L202.30,21.20 L202.10,20.30Z M101.90,20.60 L101.60,22.00 L101.60,62.40 L101.70,63.10 L102.30,63.80 L111.30,63.90 L112.00,63.40 L112.20,62.90 L112.20,37.90 L113.00,33.90 L114.20,31.90 L115.60,30.30 L117.70,29.00 L121.00,28.20 L121.90,28.20 L123.90,28.60 L125.30,29.20 L126.40,30.00 L127.60,31.60 L128.50,34.10 L128.90,37.30 L128.90,63.10 L129.30,63.70 L129.70,63.90 L138.50,63.90 L139.10,63.60 L139.40,63.20 L139.50,37.80 L140.10,34.20 L141.50,31.80 L143.00,30.20 L145.20,28.90 L148.20,28.20 L150.80,28.50 L152.00,28.90 L153.10,29.60 L154.60,31.20 L155.70,33.70 L156.00,36.30 L156.00,62.60 L156.30,63.50 L157.00,63.90 L165.80,63.90 L166.50,63.50 L166.70,63.10 L166.70,35.10 L166.40,32.00 L165.80,29.00 L164.30,25.60 L162.80,23.50 L160.40,21.40 L158.10,20.20 L154.60,19.30 L151.70,19.10 L148.50,19.50 L146.00,20.10 L143.10,21.30 L140.00,23.40 L138.00,25.60 L137.30,25.70 L136.40,24.90 L135.50,23.40 L132.80,21.10 L130.70,20.10 L127.80,19.40 L125.00,19.10 L119.60,20.00 L116.80,21.30 L112.90,24.40 L112.50,24.30 L112.20,23.80 L112.10,20.80 L111.40,20.10 L103.10,20.00 L102.30,20.20Z M60.40,22.40 L57.60,24.90 L56.30,26.70 L55.10,29.20 L54.30,32.60 L54.30,33.30 L54.70,33.80 L55.20,34.00 L64.00,33.90 L64.70,33.30 L65.10,31.70 L66.00,30.20 L67.70,28.60 L69.80,27.70 L71.70,27.40 L73.10,27.40 L76.10,28.00 L78.20,29.50 L79.00,30.80 L79.70,32.60 L80.00,36.40 L79.50,37.40 L78.60,37.70 L73.70,37.70 L67.90,38.10 L65.40,38.50 L60.10,40.10 L56.40,42.50 L54.50,44.60 L53.30,46.80 L52.90,48.10 L52.50,51.00 L52.50,52.60 L53.10,56.40 L54.20,58.80 L54.80,59.70 L56.60,61.60 L60.80,63.80 L65.80,64.70 L69.30,64.70 L73.20,64.00 L75.90,62.90 L79.40,60.40 L80.10,61.00 L80.20,63.20 L80.60,63.70 L81.10,63.90 L89.60,63.90 L90.10,63.70 L90.50,63.30 L90.70,62.60 L90.70,35.00 L90.30,31.10 L89.80,28.90 L88.80,26.50 L87.50,24.50 L85.20,22.30 L83.60,21.30 L81.30,20.30 L79.70,19.90 L73.40,19.10 L69.50,19.30 L65.40,20.10 L62.70,21.10Z M79.70,45.00 L80.00,45.70 L80.00,48.30 L79.30,51.50 L78.10,53.40 L76.20,55.10 L74.70,55.90 L72.60,56.60 L70.50,56.90 L68.70,56.90 L67.40,56.70 L65.40,55.80 L64.00,54.40 L63.40,53.20 L63.10,52.10 L63.20,49.80 L64.20,47.80 L66.10,46.20 L69.00,45.20 L71.50,44.80 L75.40,44.50 L78.90,44.50Z M16.40,4.00 L12.70,5.10 L10.90,5.90 L7.70,7.90 L5.20,10.30 L3.20,13.30 L2.10,16.10 L1.60,19.70 L1.60,21.90 L1.90,25.00 L2.90,28.20 L4.00,30.20 L5.00,31.50 L6.80,33.20 L9.50,34.90 L11.30,35.70 L15.00,36.90 L19.00,37.80 L21.70,38.10 L27.00,39.20 L29.80,40.10 L31.80,41.20 L33.40,42.70 L34.20,44.40 L34.60,47.40 L33.90,50.40 L31.60,53.30 L28.60,55.00 L25.60,55.70 L22.60,55.90 L20.60,55.70 L17.60,54.90 L15.10,53.50 L13.80,52.20 L12.40,50.00 L11.90,48.90 L11.10,45.80 L10.60,45.20 L10.10,45.00 L0.60,45.10 L0.00,45.80 L0.00,47.40 L0.30,49.20 L1.30,52.50 L3.40,56.50 L5.20,58.60 L6.40,59.70 L10.00,62.00 L14.70,63.80 L18.00,64.40 L21.60,64.80 L27.50,64.60 L32.00,63.70 L34.70,62.70 L36.90,61.60 L39.50,59.80 L42.10,57.20 L44.10,54.10 L44.70,52.80 L45.50,50.20 L45.90,47.30 L45.70,42.50 L44.70,38.70 L42.80,35.50 L40.80,33.50 L38.70,32.10 L36.80,31.10 L33.80,30.00 L32.50,29.80 L30.30,29.10 L21.30,27.60 L18.00,26.70 L16.00,25.80 L13.90,24.10 L13.10,22.80 L12.80,21.30 L12.80,18.90 L13.00,17.70 L13.90,16.00 L15.80,14.10 L18.00,13.00 L21.80,12.40 L23.20,12.40 L26.70,12.90 L29.60,14.20 L30.70,15.20 L31.90,16.70 L32.60,18.00 L33.40,20.50 L34.50,21.10 L43.40,21.00 L44.00,20.50 L44.10,20.00 L43.70,17.20 L42.60,14.00 L40.40,10.30 L38.00,7.90 L35.60,6.30 L34.20,5.60 L30.90,4.40 L26.90,3.70 L20.90,3.50Z M229.30,35.80 L229.00,37.60 L229.00,43.80 L229.30,45.60 L230.10,48.30 L231.70,51.80 L233.10,54.10 L235.10,56.60 L237.00,58.50 L239.80,60.50 L242.20,61.70 L244.80,62.70 L250.00,63.70 L254.40,63.70 L258.70,62.80 L263.60,60.80 L266.10,59.30 L269.30,56.70 L275.40,49.80 L287.80,34.40 L289.90,32.20 L291.80,30.60 L293.00,29.90 L295.60,28.90 L298.70,28.80 L300.80,29.20 L303.10,30.20 L304.80,31.40 L307.40,34.20 L308.60,36.90 L309.00,39.60 L308.80,42.70 L307.50,46.10 L306.00,48.20 L303.50,50.40 L300.90,51.60 L298.60,52.10 L294.40,52.10 L292.10,51.70 L289.40,50.50 L286.40,48.50 L283.90,46.20 L283.50,46.00 L282.80,46.00 L281.60,47.00 L277.50,52.00 L276.90,53.00 L276.90,53.70 L277.20,54.30 L278.40,55.60 L282.40,58.90 L284.20,60.00 L288.50,61.80 L292.40,62.80 L297.40,63.10 L300.80,62.80 L305.00,61.70 L307.60,60.60 L311.00,58.50 L314.40,55.30 L316.10,53.20 L317.40,51.10 L318.70,48.10 L319.60,44.30 L319.80,41.30 L319.80,38.70 L319.60,37.00 L319.60,2.70 L319.40,2.30 L318.80,1.90 L317.10,1.90 L309.80,3.00 L309.20,3.30 L308.80,3.80 L308.60,4.50 L308.40,19.50 L308.00,20.20 L307.10,20.30 L304.80,19.20 L300.80,18.10 L295.20,18.00 L293.70,18.20 L290.20,19.20 L286.20,21.20 L282.40,24.20 L280.50,26.10 L277.50,29.80 L272.20,35.80 L268.70,40.60 L261.50,49.00 L259.70,50.60 L257.50,51.80 L253.70,52.80 L249.80,52.80 L246.80,51.80 L245.10,50.80 L242.60,48.20 L241.10,45.70 L240.10,41.60 L240.10,39.70 L241.00,36.10 L241.90,34.40 L243.30,32.50 L244.30,31.50 L246.70,29.90 L248.70,29.10 L249.90,28.90 L253.00,28.90 L254.50,29.10 L257.50,30.20 L259.30,31.50 L261.10,33.30 L265.30,38.70 L266.00,38.70 L266.40,38.50 L269.40,35.10 L270.50,33.60 L270.80,32.70 L270.80,4.80 L270.70,2.80 L270.10,2.00 L268.30,2.00 L265.30,2.90 L263.40,3.20 L262.30,3.70 L261.60,4.30 L261.30,5.00 L261.20,6.20 L261.20,18.90 L260.70,19.80 L259.80,19.90 L257.80,19.00 L254.30,18.10 L249.00,18.00 L244.10,19.10 L240.80,20.50 L237.30,22.90 L233.50,26.80 L232.10,28.80 L231.10,30.70Z M387.60,1.90 L386.70,2.30 L385.40,3.30 L384.10,5.40 L383.90,6.40 L383.90,8.60 L384.40,10.30 L385.50,11.80 L386.70,12.70 L388.00,13.20 L390.20,13.50 L391.70,13.30 L393.20,12.80 L395.10,11.20 L396.00,9.40 L396.20,6.90 L395.90,5.30 L395.50,4.40 L394.20,2.90 L392.50,1.90 L390.60,1.50 L389.50,1.50Z M216.50,1.50 L214.30,2.00 L212.30,3.40 L211.10,5.40 L210.90,6.40 L210.90,8.60 L211.40,10.30 L212.30,11.60 L213.70,12.70 L215.00,13.20 L217.30,13.50 L220.00,12.90 L221.10,12.20 L222.10,11.20 L222.90,9.80 L223.20,8.30 L223.20,6.90 L222.90,5.30 L222.50,4.40 L221.10,2.80 L219.50,1.90 L217.60,1.50Z M335.30,0.20 L334.70,1.00 L334.60,1.90 L334.60,62.40 L334.80,63.30 L335.60,63.90 L344.30,63.90 L345.00,63.40 L345.20,62.80 L345.20,38.30 L346.00,34.10 L347.60,31.60 L349.20,30.10 L351.70,28.80 L354.60,28.20 L355.80,28.20 L358.70,28.80 L360.70,30.00 L361.60,30.90 L362.90,33.50 L363.40,37.60 L363.50,63.10 L364.00,63.70 L364.50,63.90 L373.40,63.80 L373.70,63.60 L374.00,62.90 L374.00,35.30 L373.70,31.50 L372.80,28.00 L371.70,25.60 L370.30,23.70 L369.10,22.50 L367.50,21.30 L364.70,20.00 L361.70,19.30 L359.40,19.10 L357.60,19.20 L353.00,20.00 L350.10,21.30 L347.80,23.00 L346.30,24.40 L345.90,24.60 L345.50,24.50 L345.20,23.90 L345.10,0.80 L344.60,0.20 L344.00,0.00 L335.90,0.00Z";

/* ---------- Component ---------- */
const mapStateToProps = ({ virtualUser, agenda, virtualEvent }) => ({
  virtualUser,
  agenda,
  virtualEvent
})

@withRouter
@connect(mapStateToProps)
class AwsPlatform extends Component {
  constructor(props) {
    super(props);
    this.state = { day: "day1", player: null };
  }

  componentDidMount() {
    const { dispatch } = this.props
    window.addEventListener("keydown", this.onKey);
    dispatch({
      type: 'agenda/GET_AGENDA',
      payload: {},
    })
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKey);
  }

  onKey = (e) => {
    if (e.key === "Escape") this.closePlayer();
  };

  setDay = (day) => this.setState({ day });

  openPlayer = (title, st) => {
    if (st === "soon") return;
    this.setState({ player: { title, st } });
  };

  closePlayer = () => this.setState({ player: null });

  jumpTo = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  logout = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'virtaluser/LOGOUT',
    })
  }
  /* ----- small render pieces ----- */
  renderPlayBtn(st, label) {
    const prefix =
      st === "live" ? "Watch live: " : st === "done" ? "Watch recording: " : "Starts later: ";
    const cls =
      "aws-play" + (st === "live" ? " aws-play-live" : st === "soon" ? " aws-play-soon" : "");
    return (
      <button
        type="button"
        className={cls}
        aria-disabled={st === "soon" ? "true" : undefined}
        aria-label={prefix + label}
        onClick={() => this.openPlayer(label, st)}
      >
        <svg viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 4l13 8-13 8z" />
        </svg>
      </button>
    );
  }

  renderTag(st, start) {
    if (st === "live")
      return (
        <span className="aws-tag-live">
          <i />
          Live
        </span>
      );
    if (st === "done") return <span className="aws-tag-soft">Recording</span>;
    return <span className="aws-tag-soft">{t12(start)}</span>;
  }

  renderHeader() {
    const { virtualUser: { name } } = this.props
    const initials = name?.trim().slice(0, 2).toUpperCase();
    return (
      <header className="aws-top">
        <div className="aws-brand">
          <img className="aws-brand-acc" src={accImg} alt="Accenture" />
          {/* <span className="aws-brand-sep" />
          <img className="aws-brand-logo" src={awsImg} alt="AWS" /> */}
          {/* <span className="aws-brand-sep" /> */}

        </div>
        <div className="aws-user">
          {/* <span className="aws-user-now">
            <i className="aws-user-dot" />
            <span>Day 1 · 03:20 PM IST</span>
          </span> */}
          {/* <span className="aws-brand-wm">
            <svg
              style={{ width: "100%", height: "auto", display: "block" }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 396.20 64.80"
            >
              <path fill="currentColor" fillRule="evenodd" d={WM_PATH} />
            </svg>
          </span> */}
          <img className="aws-brand-logo" style={{ width: '20vh' }} src={awsImg} alt="AWS" />
          <span className="aws-user-av" aria-hidden="true">{initials || 'NA'}</span>
          <button className="aws-user-out" type="button" onClick={this.logout}>Log out</button>
        </div>
      </header>
    );
  }

  renderAgenda() {
    const { agenda: { agendas
    } } = this.props
    const { day } = this.state;
    const d = AG[day];
    const lives = [];

    const keynotes = d.keynote.map((k) => {
      const st = getStatus(day, k.start, k.end);
      const hasSp = k.speakers.length > 0;
      const id = "aws-kn-" + k.start.replace(":", "");
      if (st === "live") lives.push({ id, label: k.title });
      return (
        <div key={id} id={id} className={"aws-kr" + (st === "live" ? " aws-kr-live" : "")}>
          {hasSp ? this.renderPlayBtn(st, k.title) : <span />}
          <time className="aws-kr-time">
            {t12(k.start)} – {t12(k.end)}
          </time>
          <div className="aws-kr-title">{k.title}</div>
          <div className="aws-kr-who">
            {k.speakers.map((p, i) => (
              <React.Fragment key={i}>
                {p[0]}
                <small>{p[1]}</small>
              </React.Fragment>
            ))}
          </div>
          <div className="aws-kr-status">{hasSp ? this.renderTag(st, k.start) : null}</div>
        </div>
      );
    });

    const slots = d.tracks[0].sessions.map((f, i) => {
      const st0 = getStatus(day, f.start, f.end);

      if (!f.code) {
        return (
          <div className="aws-slot" key={i}>
            <div className="aws-brk">
              <time className="aws-brk-time">
                {t12(f.start)}
                {f.end ? " – " + t12(f.end) : " onwards"}
              </time>
              {f.title}
            </div>
          </div>
        );
      }

      return (
        <div className="aws-slot" key={i}>
          <div className="aws-slot-head">
            <b>{t12(f.start)}</b> – {t12(f.end)}
            {st0 === "live" && (
              <span className="aws-tag-live">
                <i />
                Live now
              </span>
            )}
          </div>
          <div className="aws-cols">
            {d.tracks.map((t, ti) => {
              const x = t.sessions[i];
              const st = getStatus(day, x.start, x.end);
              const id = "aws-ses-" + x.code;
              if (st === "live") lives.push({ id, label: x.code + " · " + t.room });
              const extra = x.speakers.length - 2;
              return (
                <article
                  key={ti}
                  id={st === "live" ? id : undefined}
                  className={"aws-ss" + (st === "live" ? " aws-ss-live" : "")}
                >
                  <div className="aws-ss-row">
                    <span className="aws-room">
                      Track {ti + 1} · {t.room.replace(/ Ballroom| Hall/, "")}
                    </span>
                    {this.renderTag(st, x.start)}
                  </div>
                  <span className="aws-code">{x.code}</span>
                  <h3 className="aws-ss-name">{x.title}</h3>
                  <div className="aws-ss-bottom">
                    <div className="aws-ss-speakers">
                      {x.speakers.length
                        ? x.speakers.slice(0, 2).map((p, k) => (
                          <React.Fragment key={k}>
                            {k > 0 && ", "}
                            <b>{p[0]}</b>
                          </React.Fragment>
                        ))
                        : "Speakers to be announced"}
                      {extra > 0 && " +" + extra + " more"}
                    </div>
                    {this.renderPlayBtn(st, x.code + ": " + x.title)}
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      );
    });

    return (
      <>
        {lives.length > 0 && (
          <div className="aws-livebar">
            <span className="aws-tag-live">
              <i />
              Live now
            </span>
            <b>
              {lives.length} session{lives.length > 1 ? "s" : ""} streaming
            </b>
            <span className="aws-livebar-links">
              {lives.map((l) => (
                <a key={l.id} href={"#" + l.id} onClick={(e) => this.jumpTo(e, l.id)}>
                  {l.label}
                </a>
              ))}
            </span>
          </div>
        )}

        <div className="aws-sec-title">
          <h2>Opening keynotes</h2>
          <span>Main stage</span>
        </div>
        <div className="aws-kn">{keynotes}</div>

        <div className="aws-sec-title">
          <h2>Breakout sessions</h2>
          <span>4 parallel tracks</span>
        </div>
        {slots}
      </>
    );
  }

  renderPlayer() {
    const { player } = this.state;
    if (!player) return null;
    const live = player.st === "live";
    return (
      <div
        className="aws-pl"
        onClick={(e) => e.target === e.currentTarget && this.closePlayer()}
      >
        <div className="aws-pl-box" role="dialog" aria-modal="true" aria-labelledby="aws-pl-title">
          <div className="aws-pl-vid">
            <span className="aws-pl-tag">
              {live ? (
                <span className="aws-tag-live">
                  <i />
                  Live
                </span>
              ) : (
                <span className="aws-tag-soft">Recording</span>
              )}
            </span>
            <span className="aws-pl-big">
              <svg viewBox="0 0 24 24" fill="#fff">
                <path d="M7 4l13 8-13 8z" />
              </svg>
            </span>
            <span className="aws-pl-note">Video player area: the stream embeds here</span>
          </div>
          <div className="aws-pl-meta">
            <div>
              <h3 id="aws-pl-title">{player.title}</h3>
              <p>{live ? "Streaming live now" : "Recording"}</p>
            </div>
            <button className="aws-pl-close" type="button" onClick={this.closePlayer}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { day } = this.state;
    const { virtualUser: { name }, agenda: { agendas } } = this.props
    return (
      <div className="aws-app">
        {/* {this.renderHeader()} */}
        {/* <AwsHeader /> */}
        <main className="aws-shell">
          <section>
            {/* <div className="aws-head">
              <div>
                <div className="aws-eyebrow">Samriddhi 2026 · Live</div>
                <h1 className="aws-title">Agenda</h1>
              </div>
              <div className="aws-days" role="tablist">
                {DAYS.map((d) => (
                  <button
                    key={d.key}
                    role="tab"
                    aria-selected={day === d.key}
                    className={"aws-days-btn" + (day === d.key ? " aws-days-on" : "")}
                    onClick={() => this.setDay(d.key)}
                  >
                    <b>{d.label}</b>
                    <small>{d.date}</small>
                  </button>
                ))}
              </div>
            </div> */}
            {/* {this.renderAgenda()} */}
            <AwsAgenda agendas={agendas} />
          </section>

          <aside className="aws-art" aria-hidden="true">
            <img src={artImg} alt="" />
            <div className="aws-art-cap">
              <b>Tune in. Explore. Learn.</b>
              Press play on any session to watch. Sessions marked LIVE are streaming right now.
            </div>
          </aside>
        </main>

        {/* {this.renderPlayer()} */}

        {/* <div className="aws-mock">
          Mockup · simulated time: <b>Day 1, 03:20 PM</b>
        </div> */}
      </div>
    );
  }
}

export default AwsPlatform;
